/**
 * Helpers to convert to/from ITK/VTK image data
 */

import type { Image as ItkImage } from '@itk-wasm/image-io';
import type vtkImageData from '@kitware/vtk.js/Common/DataModel/ImageData';
import vtkITKHelper from '@kitware/vtk.js/Common/DataModel/ITKHelper';

export function convertItkToVtkImage(itkImage: ItkImage): vtkImageData {
    return vtkITKHelper.convertItkToVtkImage(itkImage);
}

export function convertVtkToItkImage(vtkImage: vtkImageData): ItkImage {
    return vtkITKHelper.convertVtkToItkImage(vtkImage);
}
